import React, { FC, Fragment } from 'react';
import { Grid, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { LoaderComponents } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    backgroundColor: theme.palette.divider,
  },
}));

const Loader: FC = () => {
  const classes = useStyles();
  const { Block, Divider, Image } = LoaderComponents;

  return (
    <Fragment>
      <Grid
        className={classes.root}
        container
        spacing={3}
        alignItems="center"
        justify="space-between">
        <Grid item xs>
          <Block height={32} width="60%" />
        </Grid>
        <Grid item xs={3}>
          <Block height={32} width="100%" />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={9}>
          <Paper className={classes.paper}>
            <Grid container item spacing={2} alignItems="center">
              <Grid item>
                <Image width={32} height={32} shape="rounded" />
              </Grid>
              <Grid item xs>
                <Block width="70%" />
              </Grid>
              <Grid item xs={1}>
                <Block width="100%" />
              </Grid>
            </Grid>
          </Paper>
          <Paper className={classes.paper}>
            <Grid container item spacing={2} alignItems="center">
              <Grid item>
                <Image width={32} height={32} shape="rounded" />
              </Grid>
              <Grid item xs>
                <Block width="70%" />
              </Grid>
              <Grid item xs={1}>
                <Block width="100%" />
              </Grid>
            </Grid>
          </Paper>
          <Paper className={classes.paper}>
            <Grid container item spacing={2} alignItems="center">
              <Grid item>
                <Image width={32} height={32} shape="rounded" />
              </Grid>
              <Grid item xs>
                <Block width="70%" />
              </Grid>
              <Grid item xs={1}>
                <Block width="100%" />
              </Grid>
            </Grid>
          </Paper>
          <Paper className={classes.paper}>
            <Grid container item spacing={2} alignItems="center">
              <Grid item>
                <Image width={32} height={32} shape="rounded" />
              </Grid>
              <Grid item xs>
                <Block width="70%" />
              </Grid>
              <Grid item xs={1}>
                <Block width="100%" />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={3}>
          <Paper className={classes.paper}>
            <Grid container spacing={2} direction="column" wrap="nowrap">
              <Grid item>
                <Image width="100%" height={200} shape="rounded" />
              </Grid>
              <Grid item>
                <Block width="100%" />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Divider className={classes.divider} />
      <Grid container alignItems="center" justify="flex-end">
        <Block width={150} height={40} />
      </Grid>
    </Fragment>
  );
};

export default Loader;
